import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadingStatus } from "../sessions/models/LoadingStatus";
import { ApiErrorResponse } from "../../api/types/ApiErrorResponse";
import { RootState } from "../../app/store";
import { SessionSearchResult } from "./models/SessionSearchResult";
import { MemberSearchResult } from "./models/MemberSearchResult";
import {
  fetchSearchResults,
  GlobalSearchResults,
} from "./slice-extensions/search-slice-extension";

interface SearchState {
  sessions: SessionSearchResult[];
  members: MemberSearchResult[];
  status: LoadingStatus;
  lastError?: ApiErrorResponse;
}

const initialState: SearchState = {
  sessions: [],
  members: [],
  status: LoadingStatus.Idle,
  lastError: undefined,
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    clearSearchResults: (state) => {
      state.sessions = [];
      state.members = [];
      state.status = LoadingStatus.Idle;
      state.lastError = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchResults.pending, (state) => {
        state.status = LoadingStatus.Loading;
        state.lastError = undefined;
      })
      .addCase(
        fetchSearchResults.fulfilled,
        (state, action: PayloadAction<GlobalSearchResults>) => {
          state.status = LoadingStatus.Idle;
          state.sessions = action.payload.sessions;
          state.members = action.payload.members;
        }
      )
      .addCase(fetchSearchResults.rejected, (state, action) => {
        state.status = LoadingStatus.Failed;
        state.lastError = action.payload;
      });
  },
});

export const { clearSearchResults } = searchSlice.actions;

export const selectSearchSessions = (state: RootState) => state.search.sessions;
export const selectSearchMembers = (state: RootState) => state.search.members;
export const selectSearchStatus = (state: RootState) => state.search.status;

export default searchSlice.reducer;
